import Header from "../components/Header";
import Hero from "../components/Hero";
import TourSchedule from "../components/TourSchedule";
import About from "../components/About";
import Videos from "../components/Videos";
import Gallery from "../components/Gallery";
import Press from "../components/Press";
import Partners from "../components/Partners";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const LandingPage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TourSchedule />
        <About />
        <Videos />
        <Gallery />
        <Press />
        <Contact />
        <Partners />
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;
